import { render, staticRenderFns } from "./CoozzyCommentIconImg.vue?vue&type=template&id=06d58df4&scoped=true"
import script from "./CoozzyCommentIconImg.vue?vue&type=script&lang=js"
export * from "./CoozzyCommentIconImg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d58df4",
  null
  
)

export default component.exports